var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Pattern } from '@byted/light-render';
import { Rect, Path } from '../element/index';
import { _createSymbol, getSymbolWidth, getSymbolHeight } from '../symbol';
export var patterns = [
    {
        type: 'line',
        isStagger: false,
        config: {
            spacing: 7,
            rotation: -Math.PI / 4,
        },
        style: {
            lineWidth: 3,
        },
    },
    {
        type: 'symbol',
        isStagger: true,
        config: {
            symbol: 'circle',
            size: 6,
            padding: 2,
        },
    },
    {
        type: 'line',
        isStagger: false,
        config: {
            spacing: 7,
            rotation: Math.PI / 4,
        },
        style: {
            lineWidth: 3,
        },
    },
    {
        type: 'symbol',
        isStagger: true,
        config: {
            symbol: 'triangle',
            size: 6,
            padding: 2,
        },
    },
    {
        type: 'symbol',
        isStagger: false,
        config: {
            symbol: function () {
                return new Path({
                    lineJoin: 'round',
                    lineCap: 'round',
                    brush: function (ctx) {
                        ctx.moveTo(0, 6);
                        ctx.lineTo(4, 3);
                        ctx.lineTo(8, 6);
                    },
                });
            },
            size: 8,
            padding: 0,
        },
        style: {
            lineWidth: 2,
            fill: 'none',
        },
    },
    {
        type: 'symbol',
        isStagger: true,
        config: {
            symbol: 'rect',
            size: 6,
            padding: 2,
        },
    },
];
Object.freeze(patterns);
export function createPattern(option) {
    var _a = option.type, type = _a === void 0 ? 'line' : _a;
    var _b = option.config, config = _b === void 0 ? {} : _b, _c = option.style, style = _c === void 0 ? {} : _c, backgroundColor = option.backgroundColor, _d = option.isStagger, isStagger = _d === void 0 ? type !== 'line' : _d;
    var elements = [];
    if (type === 'line') {
        var _e = config, _f = _e.spacing, spacing = _f === void 0 ? 7 : _f, _g = _e.rotation, rotation = _g === void 0 ? Math.PI / 4 : _g;
        var sinValue_1 = Math.sin(rotation);
        var colValue = Math.cos(rotation);
        var width_1 = Math.abs(Math.round(spacing / sinValue_1));
        var height_1 = Math.abs(Math.round(spacing / colValue));
        if (backgroundColor) {
            elements.push(new Rect({
                x: 0,
                y: 0,
                width: width_1,
                height: height_1,
                fill: backgroundColor,
            }));
        }
        elements.push(new Path(__assign({ brush: function (ctx) {
                if (sinValue_1 > 0 || isStagger) {
                    ctx.moveTo(0, 0);
                    ctx.lineTo(width_1, height_1);
                    ctx.moveTo(-width_1, 0);
                    ctx.lineTo(width_1, height_1 * 2);
                    ctx.moveTo(0, -height_1);
                    ctx.lineTo(width_1 * 2, height_1);
                }
                if (sinValue_1 <= 0 || isStagger) {
                    ctx.moveTo(width_1, 0);
                    ctx.lineTo(0, height_1);
                    ctx.moveTo(width_1, -height_1);
                    ctx.lineTo(-width_1, height_1);
                    ctx.moveTo(width_1 * 2, 0);
                    ctx.lineTo(0, height_1 * 2);
                }
            }, lineWidth: 3 }, style)));
        return new Pattern({
            width: width_1,
            height: height_1,
            element: elements,
        });
    }
    if (type === 'symbol') {
        var _h = config, _j = _h.symbol, symbol_1 = _j === void 0 ? 'circle' : _j, _k = _h.size, size = _k === void 0 ? 6 : _k, _l = _h.padding, padding = _l === void 0 ? 2 : _l;
        var symbolWidth = getSymbolWidth(size);
        var symbolHeight = getSymbolHeight(size);
        var x = padding;
        var y = padding;
        var width = isStagger ? (symbolWidth + padding) * 2 : symbolWidth + padding * 2;
        var height = isStagger ? (symbolHeight + padding) * 2 : symbolHeight + padding * 2;
        if (backgroundColor) {
            elements.push(new Rect({
                x: 0,
                y: 0,
                width: width,
                height: height,
                fill: backgroundColor,
            }));
        }
        if (!isStagger) {
            elements.push(_createSymbol(symbol_1, x, y, symbolWidth, symbolHeight, style));
        }
        else {
            // [左上, 右上,右下,左下,中心]
            var boxList = [
                {
                    x: -symbolWidth / 2,
                    y: -symbolHeight / 2,
                    width: symbolWidth,
                    height: symbolHeight,
                },
                {
                    x: width - symbolWidth / 2,
                    y: -symbolHeight / 2,
                    width: symbolWidth,
                    height: symbolHeight,
                },
                {
                    x: width - symbolWidth / 2,
                    y: height - symbolHeight / 2,
                    width: symbolWidth,
                    height: symbolHeight,
                },
                {
                    x: -symbolWidth / 2,
                    y: height - symbolHeight / 2,
                    width: symbolWidth,
                    height: symbolHeight,
                },
                {
                    x: width / 2 - symbolWidth / 2,
                    y: height / 2 - symbolHeight / 2,
                    width: symbolWidth,
                    height: symbolHeight,
                },
            ];
            boxList.forEach(function (box) {
                elements.push(_createSymbol(symbol_1, box.x, box.y, box.width, box.height, __assign({ lineWidth: 0 }, style)));
            });
        }
        return new Pattern({
            width: width,
            height: height,
            element: elements,
        });
    }
}
